export default __webpack_public_path__ + "static/museo-sans-bold-1672fbcc52a98fae2a1615a1bc3dbefa.eot";